import DOMPurify from 'dompurify';

import { replaceEmailTemplateVariables } from './replaceEmailTemplateVariables';

const EMAIL_ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'em',
  's',
  'u',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'ul',
  'ol',
  'li',
  'blockquote',
  'pre',
  'code',
  'hr',
  'a',
  'span',
];

const EMAIL_ALLOWED_ATTR = ['href', 'target', 'rel'];

export const sanitizeEmailTemplateHtml = (value: string) =>
  DOMPurify.sanitize(value, {
    ALLOWED_TAGS: EMAIL_ALLOWED_TAGS,
    ALLOWED_ATTR: EMAIL_ALLOWED_ATTR,
  });

export const prepareEmailBodyHtml = (raw: string | undefined): string => {
  if (!raw?.trim()) {
    return '';
  }

  return sanitizeEmailTemplateHtml(replaceEmailTemplateVariables(raw.trim()));
};
